import './App.css';
import Creneau from './component/creneau/Creneau';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Niveau1AncInd from './component/indian_ancestor/levels/niveau-1/FamilyTree';

function App() {
  const isDarkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  const containerStyle = isDarkMode ? "dark:bg-black" : "bg-white";

  return (
    <div className={`App ${containerStyle}`}>
      <header className="App-header">
        <Router>
          <Routes>
            <Route path="/" element={<Navigate to="/ancetre" />} />
            <Route path="/ancetre" element={<Niveau1AncInd />} />
            <Route path="/creneau" element={<Creneau />} />
          </Routes>
        </Router>
      </header>
    </div>
  );
}

export default App;